var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_8418",
    "data-name": "\\u7EC4 8418",
    transform: "translate(-797 -586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_4825",
    "data-name": "\\u8DEF\\u5F84 4825",
    d: "M76,254H68a2,2,0,0,1-2-2V240a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v12A2,2,0,0,1,76,254Z",
    transform: "translate(735 349)",
    fill: "rgba(153,153,153,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_14059",
    "data-name": "\\u77E9\\u5F62 14059",
    width: 1,
    height: 18,
    rx: 0.5,
    transform: "translate(797 586)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_14060",
    "data-name": "\\u77E9\\u5F62 14060",
    width: 14,
    height: 1,
    rx: 0.5,
    transform: "translate(797 586)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_14061",
    "data-name": "\\u77E9\\u5F62 14061",
    width: 1,
    height: 18,
    rx: 0.5,
    transform: "translate(810 586)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_14062",
    "data-name": "\\u77E9\\u5F62 14062",
    width: 14,
    height: 1,
    rx: 0.5,
    transform: "translate(797 603)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_14063",
    "data-name": "\\u77E9\\u5F62 14063",
    width: 8,
    height: 1,
    rx: 0.5,
    transform: "translate(800 590)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_14199",
    "data-name": "\\u77E9\\u5F62 14199",
    width: 8,
    height: 1,
    rx: 0.5,
    transform: "translate(800 593)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_14200",
    "data-name": "\\u77E9\\u5F62 14200",
    width: 5,
    height: 1,
    rx: 0.5,
    transform: "translate(800 596)",
    fill: "#999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/证件.93dd8c8ca4d3977e520dc0bed58b6ede.svg";
export { ForwardRef as ReactComponent };